import React from 'react';
import { useHistory } from 'react-router-dom';
import useChatStore from '../../stores/useChatStore';
import useIsMobile from './useIsMobile';
import { routeAllowedOnInstance } from '../../navigation/routeInstances';

export interface FlerpieNavigate {
  kind: string;
  to: string;
  label: string;
}

/**
 * The answer to "would you like me to take you there?". The server already
 * resolved the record and checked the user against the route's gate, so this
 * only asks whether this deployment has the page at all, then waits for the
 * click. On a phone the panel closes so the page is visible.
 */
const FlerpieNavigateButton = ({ navigate }: { navigate: FlerpieNavigate }) => {
  const history = useHistory();
  const toggleOpen = useChatStore((s: { toggleOpen: () => void }) => s.toggleOpen);
  const isOpen = useChatStore((s: { isOpen: boolean }) => s.isOpen);
  const isMobile = useIsMobile();
  if (!navigate?.to || !routeAllowedOnInstance(navigate.to)) return null;

  const go = () => {
    history.push(navigate.to);
    if (isMobile && isOpen) toggleOpen();
  };

  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={go}
        className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] font-medium
                   bg-primary/15 text-primary hover:bg-primary/25 transition-colors duration-200"
      >
        Take me there
        <span className="opacity-70 font-normal truncate max-w-[180px]">{navigate.label}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <path d="M2 6H10M6 2L10 6L6 10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
};

export default FlerpieNavigateButton;
